export default __webpack_public_path__ + "static/media/vhLogo.0d79caa9.svg";